module.exports = __webpack_public_path__ + "static/media/gear-active-icon.43ffc549.svg";